import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "이용약관 | 제이아이앤씨 JI&C",
  "description": "제이아이앤씨 웹사이트 이용약관. 서비스 이용 조건, 회원 가입, 저작권, 면책 조항 및 분쟁 해결에 관한 안내.",
  "url": import.meta.env.VITE_SITE_URL + "/terms",
  "inLanguage": "ko",
  "isPartOf": {
    "@type": "WebSite",
    "name": "제이아이앤씨 JI&C",
    "url": import.meta.env.VITE_SITE_URL
  }
};

export default function TermsOfService() {
  return (
    <>
      <JsonLd data={webPageSchema} />
      <div className="w-full min-w-[1024px] lg:min-w-0 bg-white text-navy-900">
        <Navbar />
        <main>
          <section className="pt-32 pb-20 px-6 md:px-12 lg:px-16">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold text-navy-900 mb-3">
                이용약관
              </h1>
              <p className="text-sm text-navy-500 mb-10">시행일: 2026년 7월 27일</p>

              <div className="space-y-10 text-sm leading-relaxed text-navy-800">
                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제1조 (목적)</h2>
                  <p>
                    본 약관은 주식회사 제이아이앤씨(이하 &apos;회사&apos;)가 운영하는 웹사이트(www.jinc1.com, 이하
                    &apos;사이트&apos;)에서 제공하는 인터넷 관련 서비스(이하 &apos;서비스&apos;)의 이용과 관련하여
                    회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제2조 (용어의 정의)</h2>
                  <ul className="list-disc pl-5 space-y-1 text-navy-700">
                    <li>
                      <strong>&apos;사이트&apos;</strong>란 회사가 재화 또는 서비스를 이용자에게 제공하기 위하여 컴퓨터 등
                      정보통신설비를 이용하여 재화 또는 서비스를 거래할 수 있도록 설정한 가상의 영업장을 말합니다.
                    </li>
                    <li>
                      <strong>&apos;이용자&apos;</strong>란 사이트에 접속하여 본 약관에 따라 회사가 제공하는 서비스를 받는
                      회원 및 비회원을 말합니다.
                    </li>
                    <li>
                      <strong>&apos;회원&apos;</strong>이란 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 정보를
                      지속적으로 제공받으며 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.
                    </li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제3조 (약관의 게시와 개정)</h2>
                  <p>
                    회사는 본 약관의 내용을 이용자가 쉽게 알 수 있도록 사이트 초기 화면에 게시합니다. 회사는 필요한 경우
                    관련 법령을 위배하지 않는 범위 내에서 본 약관을 개정할 수 있으며, 약관을 개정할 경우 적용일자 및
                    개정 사유를 명시하여 현행 약관과 함께 그 적용일자 7일 전부터 적용일자 전일까지 공지합니다.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제4조 (서비스의 제공 및 변경)</h2>
                  <p>회사는 다음과 같은 서비스를 제공합니다.</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-navy-700">
                    <li>회사 소개 및 사업 분야 안내</li>
                    <li>시공 사례 및 포트폴리오 열람</li>
                    <li>견적 문의 및 상담 신청</li>
                    <li>채용 정보 제공</li>
                    <li>기타 회사가 자체 개발하거나 제휴 계약을 통해 제공하는 서비스</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제5조 (서비스의 중단)</h2>
                  <p>
                    회사는 컴퓨터 등 정보통신설비의 보수 점검, 교체, 고장, 통신 두절 또는 운영상 상당한 이유가 있는 경우
                    서비스 제공을 일시적으로 중단할 수 있습니다. 이 경우 회사는 사전에 사이트를 통하여 공지합니다.
                    다만, 회사가 통제할 수 없는 사유로 인한 서비스 중단의 경우에는 사후에 공지할 수 있습니다.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제6조 (회원가입)</h2>
                  <p>
                    이용자는 회사가 정한 가입 양식에 따라 회원 정보를 기입한 후 본 약관에 동의한다는 의사 표시를 함으로써
                    회원 가입을 신청합니다. 회사는 이용자의 회원 가입 신청에 대하여 특별한 사유가 없는 한 승낙합니다.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제7조 (이용자의 의무)</h2>
                  <p>이용자는 다음 행위를 하여서는 안 됩니다.</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-navy-700">
                    <li>타인의 개인정보 도용</li>
                    <li>회사가 게시한 정보의 무단 변경</li>
                    <li>회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시</li>
                    <li>회사 및 기타 제3자의 저작권 등 지식재산권에 대한 침해</li>
                    <li>회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                    <li>외설적이거나 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 사이트에 공개 또는 게시하는 행위</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제8조 (저작권의 귀속 및 이용 제한)</h2>
                  <p>
                    회사가 작성한 저작물에 대한 저작권 및 기타 지식재산권은 회사에 귀속됩니다. 이용자는 사이트를 이용함으로써
                    얻은 정보 중 회사에게 지식재산권이 귀속된 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포,
                    방송 기타 방법에 의하여 영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제9조 (견적 및 상담)</h2>
                  <p>
                    사이트를 통한 견적 요청 및 상담 신청은 실제 계약을 보장하지 않으며, 현장 실측 및 상담을 통해
                    최종 견적이 확정됩니다. 회사는 이용자가 제공한 정보를 바탕으로 최선의 상담 서비스를 제공하나,
                    실제 공사 조건에 따라 견적 내용이 변경될 수 있습니다.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제10조 (면책 조항)</h2>
                  <p>회사는 다음과 같은 사유로 발생한 손해에 대하여 책임을 부담하지 않습니다.</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-navy-700">
                    <li>천재지변, 전쟁, 테러 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우</li>
                    <li>이용자의 귀책 사유로 인한 서비스 이용 장애</li>
                    <li>이용자가 사이트에 게시한 정보, 자료, 사실의 신뢰도 및 정확성</li>
                    <li>회사와 이용자 간의 개별 계약이나 별도 합의 없이 사이트 정보만을 근거로 한 의사 결정</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제11조 (분쟁 해결)</h2>
                  <p>
                    회사와 이용자 간에 발생한 분쟁에 관한 소송은 민사소송법상 관할 법원을 전속적 관할로 합니다.
                    본 약관에 명시되지 않은 사항은 관련 법령 및 상관례에 따릅니다.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-navy-900 mb-3">제12조 (문의처)</h2>
                  <p>본 약관과 관련한 문의사항은 아래 연락처로 문의해 주시기 바랍니다.</p>
                  <div className="mt-3 p-4 bg-navy-50 rounded-lg space-y-1">
                    <p><strong>회사명:</strong> 주식회사 제이아이앤씨</p>
                    <p><strong>대표:</strong> 김승현</p>
                    <p><strong>연락처:</strong> 051-727-0477</p>
                    <p><strong>이메일:</strong> ksh10090000@hanmail.net</p>
                    <p><strong>주소:</strong> 부산시 기장군 장안읍 좌천로 20, 101호</p>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}